<template>
  <div>
    <ShareDetailToolbar/>
    <v-tabs :color="ui.bkgdColor" :slider-color="ui.sliderColor" v-model="tab">
      <v-tab href="#tab-1">
        <v-tabs-slider/>
        <div :class="ui.textColorSecondary">
          Info
        </div>
      </v-tab>
      <v-tab href="#tab-2">
        <div :class="ui.textColorSecondary">
          Auth.
        </div>
      </v-tab>
      <v-tab href="#tab-3">
        <div :class="ui.textColorSecondary">
          Verify
        </div>
      </v-tab>
      <v-tab href="#tab-4">
        <div :class="ui.textColorSecondary">
          Rev.
        </div>
      </v-tab>
      <!-- Basic / Info -->
      <v-tab-item :key="1" :value="'tab-1'">
        <AccessDetailInfo/>
      </v-tab-item>
      <!-- Contact Info -->
      <v-tab-item :key="2" :value="'tab-2'">
        <AccessDetailAuth v-if="this.tab === 'tab-2'"/>
      </v-tab-item>
      <v-tab-item :key="3" :value="'tab-3'">
        <TransitionsAccess v-if="this.tab === 'tab-3'"/>
      </v-tab-item>
      <!-- <Revisions/> -->
      <v-tab-item :key="4" :value="'tab-4'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-4'">
          <RevisionDash/>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <DetailAuth/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AccessDetailInfo from "@/support/access/components/AccessDetailInfo";
import AccessDetailAuth from "@/support/access/components/AccessDetailAuth";
import RevisionDash from "@/document/revisions/components/RevisionDash";
import DetailAuth from "@/support/detail/components/DetailAuth";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import TransitionsAccess from "@/support/transitions/components/TransitionsAccess";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import ShareDetailToolbar from "@/support/share/components/ShareDetailToolbar";

export default {
  components: {
    AccessDetailAuth,
    AccessDetailInfo,
    DetailAuth,
    RevisionDash,
    TransitionsAccess,
    ShareDetailToolbar
  },
  mixins: [apptheme, numberFunctions, storeFunctions, displayFunctions],
  data() {
    return {
      valid: true,
      value: "",
      tab: ""
    };
  },
  created() {
    this.startAccessStore();
  },
  beforeDestroy() {
    this.$store.dispatch("changeDocumentRevMod", null);
    // this.resetStoreDetail();
  },
  // eslint-disable-next-line
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDataSavePendingIndication", "getDetail"]),
    dataSavePendingColor() {
      // eslint-disable-next-line
      if (this.getDataSavePendingIndication === true) {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    },
    tag() {
      let tag = this.getDetail.basic.tag;
      if (tag === "G1") {
        if (this.getDetail.basic.tags === "C1") {
          tag = "C1";
        } else {
          tag = this.getDetail.basic.tag;
        }
      } else {
        tag = this.getDetail.basic.tag;
      }
      return tag;
    },
    item() {
      let obj = {
        title: "",
        tag: ""
      };
      let tagd = this.getDetail.basic.tagd;
      let tags = this.getDetail.basic.tags;
      if (tagd === "C1" && tags === "U1") {
        obj.title = "Company Access";
        obj.tag = "C1";
      } else if (tagd === "Z5" && tags === "C1") {
        obj.title = "New Company";
        obj.tag = "C1";
      } else if (tagd === "U1" && tags === "C1") {
        obj.title = "Company Access";
        obj.tag = "C1";
      } else if (tagd === "U1" && tags === "F1") {
        obj.title = "Facility Access";
        obj.tag = "F1";
      } else if (tagd === "F1" && tags === "U1") {
        obj.title = "Facility Access";
        obj.tag = "F1";
      } else {
        obj.title = this.result.basic.title;
      }
      return obj;
    }
  }
};
</script>
